'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ViewLandingPageEvent } from '@marketplace-web/company-info/company-landing-page-data'

import AccessibilityFirstSection from './AccessibilityFirstSection'
import AccesibilitySecondSection from './AccessibilitySecondSection'
import AccessibilityThirdSection from './AccessibilityThirdSection'
import AccessibilityFourthSection from './AccessibilityFourthSection'
import { ACCESSIBILITY_URL } from '../../constants/routes'

const Accessibility = () => {
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: 'accessibility',
        path: ACCESSIBILITY_URL,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  return (
    <div className="accessibility-landingpage">
      <AccessibilityFirstSection />
      <AccesibilitySecondSection />
      <AccessibilityThirdSection />
      <AccessibilityFourthSection />
    </div>
  )
}

export default Accessibility
